import { Component, OnInit, Input, SimpleChanges} from '@angular/core';

@Component({
    selector: 'spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
    standalone: false
})
export class SpinnerComponent implements OnInit {
    
    @Input() public showSpinner = false;

    constructor() { }

    ngOnInit() {
        
    }
    ngOnChanges(changes: SimpleChanges){
        // do something here
    }
}